import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSessionPersistence } from '../../hooks/useSessionPersistence';

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const { session } = useSessionPersistence();

  // Check if user is logged in (has account token or completed onboarding)
  const isLoggedIn = session.accountToken || session.onboardingComplete;

  const handleBackClick = () => {
    if (isLoggedIn) {
      // Take logged in user to dashboard
      navigate('/frame-140');
    } else {
      // Take guest to beginning of flow
      const env = import.meta.env.VITE_ENVIRONMENT;
      const homeUrl = env === 'preprod' 
        ? 'https://preprod.endofanera.ai' 
        : 'https://my.endofanera.ai';
      window.location.href = homeUrl;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-cyan-900 to-cyan-950 flex flex-col items-center justify-center px-4">
      {/* 404 Heading */}
      <h1 className="text-[150px] font-bold text-white mb-4 leading-none">
        404
      </h1>

      {/* Error Message */}
      <div className="text-center mb-8">
        <p className="text-white text-base mb-1">
          Page Not Found
        </p>
        <p className="text-white text-base">
          The page you are looking for does not exist or has been moved.
        </p>
      </div>

      {/* Back Button */}
      <button
        onClick={handleBackClick}
        className="bg-teal-600 hover:bg-teal-700 text-white font-medium px-8 py-3 rounded-md transition-colors duration-200"
      >
        {isLoggedIn ? 'Back to My Dashboard' : 'Back to Home Page'}
      </button>
    </div>
  );
};

export default NotFound;
